export const buttonConstant = {
    edit: 'BUTTON.EDIT',
    add: 'BUTTON.ADD',
    close: 'BUTTON.CLOSE',
    save: 'BUTTON.SAVE',
    saving: 'BUTTON.SAVING',
    login: 'BUTTON.LOGIN',
    logout: 'BUTTON.LOGOUT',
    googleSignin: 'BUTTON.GOOGLE_SIGNIN',
    createForm: 'BUTTON.CREATE_FORM',
    createWorkspace: 'BUTTON.CREATE_WORKSPACE',
    updateWorkspace: 'BUTTON.UPDATE_WORKSPACE',
    next: 'BUTTON.NEXT',
    previous: 'BUTTON.PREVIOUS',
    done: 'BUTTON.DONE',
    upload: 'BUTTON.UPLOAD',
    submit: 'BUTTON.SUBMIT',
    share: 'BUTTON.SHARE',
    deleteForm: 'BUTTON.DELETE_FORM',
    deleteAccount: 'BUTTON.DELETE_ACCOUNT',
    pro: 'BUTTON.PRO',
    getIn: 'BUTTON.GETIN',
    upgrade: 'BUTTON.UPGRADE',
    upgradeToPro: 'BUTTON.UPGRADE_TO_PRO',
    importForms: 'BUTTON.IMPORT_FORMS',
    uploadUnlimitedForms: 'BUTTON.UPLOAD_UNLIMITED_FORMS',
    copyLink: 'BUTTON.COPY_LINK',
    customizeLink: 'BUTTON.CUSTOMIZE_LINK',
    requestAnIntegration: 'BUTTON.REQUEST_AN_INTEGRATION',
    continue: 'BUTTON.CONTINUE',
    checkMyData: 'BUTTON.CHECK_MY_DATA',
    sendCode: 'BUTTON.SEND_CODE',
    verify: 'BUTTON.VERIFY',
    continueWithGoogle: 'BUTTON.CONTINUE_WITH_GOOGLE',
    resend: 'BUTTON.RESEND',
    inviteCollaborator: 'BUTTON.INVITE_COLLABORATOR',
    sendInvitation: 'BUTTON.SEND_INVITATION',
    resendInvitation: 'STAFF.MEMBERS.RESEND_INVITATION',
    update: 'BUTTON.UPDATE',
    cancel: 'BUTTON.CANCEL',
    delete: 'BUTTON.DELETE',
    deleteNow: 'BUTTON.DELETE_NOW',
    updateUrl: 'BUTTON.UPDATE_URL',
    resendCode: 'BUTTON.RESEND_CODE',
    saveImage: 'BUTTON.SAVE_IMAGE',
    back: 'BUTTON.BACK',
    joinWorkspace: 'BUTTON.JOIN_WORKSPACE',
    decline: 'BUTTON.DECLINE',
    importNow: 'BUTTON.IMPORT_NOW',
    yes: 'BUTTON.YES',
    no: 'BUTTON.NO',
    requestForDeletion: 'BUTTON.REQUEST_FOR_DELETION',
    requestedForDeletion: 'BUTTON.REQUESTED_FOR_DELETION',
    removeInvitation: 'BUTTON.REMOVE_INVITATION',
    deleteMember: 'BUTTON.DELETE_MEMBER',
    skip: 'BUTTON.SKIP',
    updateNow: 'BUTTON.UPDATE_NOW',
    saveChanges: 'BUTTON.SAVE_CHANGES',
    addGroup: 'BUTTON.ADD_GROUP',
    addMembers: 'BUTTON.ADD_MEMBERS',
    saveGroup: 'BUTTON.SAVE_GROUP',
    addRegex: 'BUTTON.ADD_REGEX',
    addMember: 'BUTTON.ADD_MEMBER',
    addForm: 'BUTTON.ADD_FORM',
    addToGroup: 'BUTTON.ADD_TO_GROUP',
    open: 'BUTTON.OPEN',
    newForm: 'BUTTON.NEW_FORM'
};
